<template>
  <div class="mdl-shadow--1dp mdl-card_mais_amigos">
    <div class="mais-amigos-card__info-div">
      <img src="/images/mais-amigos/logo-mais-amigos.png" alt="Logo Mais Amigos" class="mais-amigos__logo-banner--home">
      <p class="mais-amigos__text-banner--home">
        Sua indicação vale dinheiro! Para cada pessoa indicada que inicie seu Projeto de Vida no Mais Futuro, você
        receberá um bônus na sua previdência.
      </p>
      <div class="container-filho">
        <MiniCardAcao :texto="'Acessar Mais Amigos'" :router="'/maisamigos'" />
      </div>
    </div>
  </div>
</template>

<script>

import MiniCardAcao from './MiniCardAcao.vue';

export default {
  name: 'MaisAmigosCard',
  components: {
    MiniCardAcao
  }
}
</script>

<style>
.mdl-card_mais_amigos {
  height: 370px;
  max-width: 630px;
  padding: 0;
  margin: auto;
  margin-top: 30px;
  border-radius: 0px;
  background-color: #6ab4d9;
  background-image: url(../../public/images/mais-amigos/banner-home-mais-amigos.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.mais-amigos-card__info-div {
  display: flex;
  flex-flow: column
}

.mais-amigos__logo-banner--home {
  width: 140px;
}

.mais-amigos__text-banner--home {
  height: 150px;
  margin: 0 0 20px 15px;
  max-width: 35%;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  display: flex;
  align-items: center;
}

.mais-amigos_button {
  background-color: #307ABB;
  border-radius: 12px;
  cursor: pointer;
}
</style>
